import VueI18n from "vue-i18n";

const DEFAULT_LOCALE = "nl-NL";
const DEFAULT_CURRENCY = "EUR";
const DEFAULT_MESSAGES = {
  [DEFAULT_LOCALE]: {}
};

export function initI18n(
  locale = DEFAULT_LOCALE,
  currency = DEFAULT_CURRENCY,
  messages = DEFAULT_MESSAGES
) {
  const numberFormats = {};
  numberFormats[locale] = {
    currency: {
      style: "currency",
      currency: currency
    }
  };

  return new VueI18n({
    locale: locale,
    fallbackLocale: locale,
    numberFormats,
    messages
  });
}
